import { Path } from '@src/navigations/routes';
import React from 'react';
import { useLocation } from 'react-router-dom';
import AsideContentRemittance from '../asideContentRemittance';
import AsideContentBusiness from '../asideContentBusiness';
import AsideContentWhiteLabel from '../asideContentWhiteLabel';

const AsideContent = () => {
  const { pathname } = useLocation();

  if (pathname === Path.RegisterRemittance) {
    return <AsideContentRemittance />;
  }

  if (pathname === Path.RegisterWhiteLabel) {
    return <AsideContentWhiteLabel />;
  }

  return <AsideContentBusiness />;
};

export default AsideContent;
